import { render, staticRenderFns } from "./CardMoveDialog.vue?vue&type=template&id=4c1902ec&scoped=true"
import script from "./CardMoveDialog.vue?vue&type=script&lang=js"
export * from "./CardMoveDialog.vue?vue&type=script&lang=js"
import style0 from "./CardMoveDialog.vue?vue&type=style&index=0&id=4c1902ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1902ec",
  null
  
)

export default component.exports